/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportSkillAreasFromBSP$Params {
  patientID?: number;
}

export function ImportSkillAreasFromBSP(http: HttpClient, rootUrl: string, params?: ImportSkillAreasFromBSP$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, ImportSkillAreasFromBSP.PATH, 'post');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: parseImportMessageBody(r.body) }) as StrictHttpResponse<string>;
    })
  );
}

function parseImportMessageBody(body: unknown): string {
  if (body == null) {
    return '';
  }
  if (typeof body !== 'string') {
    return String(body);
  }
  const trimmed = body.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    try {
      const parsed = JSON.parse(trimmed);
      if (typeof parsed === 'string') {
        return parsed;
      }
    } catch {
      // Keep the raw text when it is not valid JSON.
    }
  }
  return trimmed;
}

ImportSkillAreasFromBSP.PATH = '/api/Supervisor/ImportSkillAreasFromBSP';
